$(document).ready(function () {
$(".DstFeaturedSlider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay:false,
    dots: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 45.8332C36.5059 45.8332 45.8333 36.5058 45.8333 24.9998C45.8333 13.4939 36.5059 4.1665 25 4.1665C13.494 4.1665 4.16663 13.4939 4.16663 24.9998C4.16663 36.5058 13.494 45.8332 25 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 16.6665L16.6666 24.9998L25 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3333 25H16.6666" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9999 45.8332C13.494 45.8332 4.16658 36.5058 4.16658 24.9998C4.16658 13.4939 13.494 4.1665 24.9999 4.1665C36.5059 4.1665 45.8333 13.4939 45.8333 24.9998C45.8333 36.5058 36.5059 45.8332 24.9999 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.9999 16.6665L33.3333 24.9998L24.9999 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6666 25H33.3333" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',   
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  $('.image-text-slide-main').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,   
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path d="M25 46.4482C36.5059 46.4482 45.8333 37.1208 45.8333 25.6148C45.8333 14.1089 36.5059 4.78149 25 4.78149C13.494 4.78149 4.16663 14.1089 4.16663 25.6148C4.16663 37.1208 13.494 46.4482 25 46.4482Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 17.2815L16.6666 25.6148L25 33.9482" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3333 25.6147H16.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path d="M24.9999 46.474C13.494 46.474 4.16658 37.1466 4.16658 25.6407C4.16658 14.1348 13.494 4.80737 24.9999 4.80737C36.5059 4.80737 45.8333 14.1348 45.8333 25.6407C45.8333 37.1466 36.5059 46.474 24.9999 46.474Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.9999 17.3074L33.3333 25.6407L24.9999 33.974" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6666 25.6406H33.3333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.customer-review-slider').slick({
    infinite: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 45.8332C36.5059 45.8332 45.8333 36.5058 45.8333 24.9998C45.8333 13.4939 36.5059 4.1665 25 4.1665C13.494 4.1665 4.16663 13.4939 4.16663 24.9998C4.16663 36.5058 13.494 45.8332 25 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 16.6665L16.6666 24.9998L25 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3333 25H16.6666" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9999 45.8332C13.494 45.8332 4.16658 36.5058 4.16658 24.9998C4.16658 13.4939 13.494 4.1665 24.9999 4.1665C36.5059 4.1665 45.8333 13.4939 45.8333 24.9998C45.8333 36.5058 36.5059 45.8332 24.9999 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.9999 16.6665L33.3333 24.9998L24.9999 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6666 25H33.3333" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
  });

$('.DstMainSlider').slick({
  centerMode: true,
  // centerPadding: '60px',
   //variableWidth: true,
    dots: false,
    infinite: true,
  autoplay: true,
  autoplaySpeed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 45.8332C36.5059 45.8332 45.8333 36.5058 45.8333 24.9998C45.8333 13.4939 36.5059 4.1665 25 4.1665C13.494 4.1665 4.16663 13.4939 4.16663 24.9998C4.16663 36.5058 13.494 45.8332 25 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 16.6665L16.6666 24.9998L25 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.3333 25H16.6666" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9999 45.8332C13.494 45.8332 4.16658 36.5058 4.16658 24.9998C4.16658 13.4939 13.494 4.1665 24.9999 4.1665C36.5059 4.1665 45.8333 13.4939 45.8333 24.9998C45.8333 36.5058 36.5059 45.8332 24.9999 45.8332Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.9999 16.6665L33.3333 24.9998L24.9999 33.3332" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6666 25H33.3333" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        // centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        // centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});
  

  
  $(document).ready(function() {
          console.log('ITG Ready');
          $(document).on('click','.cart-but form[action="/cart/add"]',function(e) {
            e.preventDefault();
            var ID = $(this).find('[name="id"]').attr("value"); 
            var Quantity = $(this).find('[name="quantity"]').attr("value");
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: Quantity,
                    id: ID
                  },
                  dataType: 'json', 
                  success: function (data) {
                    
                     console.log(data);
                    
                    
                    $("#Cart-Drawer .side-panel-inner").load(location.href + " #Cart-Drawer .side-panel-inner");
                        //dispatchCustomEvent('cart-drawer:open');

                            document.body.classList.add('open-cc');
                            document.body.classList.add('open-cart');
                            document.getElementById('Cart-Drawer').classList.add('active');
                            dispatchCustomEvent('cart-drawer:open');
                            
                            // dispatchCustomEvent('cart-drawer:refresh');

                    jQuery.getJSON('/cart.js', function(cart) {

                      console.log(cart);
                          $('.thb-secondary-item-icon .thb-item-count').text(cart.item_count);
                            console.log(cart.item_count);

                            dispatchCustomEvent('cart:item-added', {
                              product: cart.hasOwnProperty('items') ? cart.items[0] : cart
                            });
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true
                            }));

                            
                      
                    } );

                            dispatchCustomEvent("cart:item-added", function (evt) {
                                console.log("Cart item added");
                                console.log(evt.detail.data);
                            });
                          // new CartDrawer();
                          console.log('Done');
                          // $("#cart-drawer-toggle").load(location.href + " #cart-drawer-toggle");
                    

                    
                     /* 
                       document.addEventListener("cart:item-added", function (evt) {
                            console.log("Cart item added");
                            console.log(evt.detail.data);
                        });
                        document.addEventListener("cart-drawer:open", function (evt) {
                            console.log("Cart drawer opened");
                        });
                    */
                    
                  }
               });
          });

      });
  
});